import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Content_ProviderCommonFragmentFragmentDoc } from './ContentProviderCommonFragment.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ContentList_AllYiTagsListQueryQueryVariables = Types.Exact<{
  path: Types.Scalars['String']['input']
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  language?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >
}>

export type ContentList_AllYiTagsListQueryQuery = {
  __typename?: 'Query'
  contentList?: {
    __typename?: 'ContentListResponse'
    content?: Array<{
      __typename?: 'Content'
      id?: string | null
      language?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null
}

export const ContentList_AllYiTagsListQueryDocument = gql`
  query ContentList_AllYITagsListQuery(
    $path: String!
    $offset: Int = 0
    $limit: Int = 25
    $language: [String!] = ["en"]
  ) {
    contentList(
      offset: $offset
      limit: $limit
      where: { contentType: { eq: "tag" }, path: { ilike: $path }, language: { in: $language } }
      contentReferencesTo: [{ type: "yi-content-type", contentType: "tag" }]
    ) {
      content {
        id
        language
        title
        contentId
        contentType
        published
        contentProvider {
          ...Content_ProviderCommonFragment
          providerKey
        }
      }
    }
  }
  ${Content_ProviderCommonFragmentFragmentDoc}
`

/**
 * __useContentList_AllYiTagsListQueryQuery__
 *
 * To run a query within a React component, call `useContentList_AllYiTagsListQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentList_AllYiTagsListQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentList_AllYiTagsListQueryQuery({
 *   variables: {
 *      path: // value for 'path'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useContentList_AllYiTagsListQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContentList_AllYiTagsListQueryQuery,
    ContentList_AllYiTagsListQueryQueryVariables
  > &
    (
      | { variables: ContentList_AllYiTagsListQueryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContentList_AllYiTagsListQueryQuery,
    ContentList_AllYiTagsListQueryQueryVariables
  >(ContentList_AllYiTagsListQueryDocument, options)
}
export function useContentList_AllYiTagsListQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContentList_AllYiTagsListQueryQuery,
    ContentList_AllYiTagsListQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContentList_AllYiTagsListQueryQuery,
    ContentList_AllYiTagsListQueryQueryVariables
  >(ContentList_AllYiTagsListQueryDocument, options)
}
// @ts-ignore
export function useContentList_AllYiTagsListQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContentList_AllYiTagsListQueryQuery,
    ContentList_AllYiTagsListQueryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ContentList_AllYiTagsListQueryQuery,
  ContentList_AllYiTagsListQueryQueryVariables
>
export function useContentList_AllYiTagsListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentList_AllYiTagsListQueryQuery,
        ContentList_AllYiTagsListQueryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ContentList_AllYiTagsListQueryQuery | undefined,
  ContentList_AllYiTagsListQueryQueryVariables
>
export function useContentList_AllYiTagsListQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContentList_AllYiTagsListQueryQuery,
        ContentList_AllYiTagsListQueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContentList_AllYiTagsListQueryQuery,
    ContentList_AllYiTagsListQueryQueryVariables
  >(ContentList_AllYiTagsListQueryDocument, options)
}
export type ContentList_AllYiTagsListQueryQueryHookResult = ReturnType<
  typeof useContentList_AllYiTagsListQueryQuery
>
export type ContentList_AllYiTagsListQueryLazyQueryHookResult = ReturnType<
  typeof useContentList_AllYiTagsListQueryLazyQuery
>
export type ContentList_AllYiTagsListQuerySuspenseQueryHookResult = ReturnType<
  typeof useContentList_AllYiTagsListQuerySuspenseQuery
>
export type ContentList_AllYiTagsListQueryQueryResult = Apollo.QueryResult<
  ContentList_AllYiTagsListQueryQuery,
  ContentList_AllYiTagsListQueryQueryVariables
>
